<script setup lang="ts">
const storeIndex = useStoreIndex()
type Emits = { (event: 'token', value: any): void }
const emits = defineEmits<Emits>()

const initReCaptcha = () => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
  document.body.appendChild(script)

  setTimeout(() => {
    // @ts-expect-error: window.grecaptcha
    if (typeof window.grecaptcha !== 'undefined') {
      // @ts-expect-error: window.grecaptcha
      window.grecaptcha.render('recaptcha', {
        sitekey: storeIndex.state.site.recaptcha_api_key,
        size: 'invisible',
        badge: 'inline',
        callback: onToken,
      })
    }
  }, 2000)
}

const execute = () => {
  // @ts-expect-error: window.grecaptcha
  if (typeof window.grecaptcha !== 'undefined') {
    // @ts-expect-error: window.grecaptcha
    window.grecaptcha.ready(function () {
      // @ts-expect-error: window.grecaptcha
      window.grecaptcha.execute()
    })
  }
}

const onToken = (token) => {
  emits('token', token)
}

onMounted(() => {
  nextTick(() => {
    initReCaptcha()
  })
})

defineExpose({ execute })
</script>

<template>
  <div class="c-recaptcha" />
</template>

<style lang="scss" scoped>
.c-recaptcha {
  display: flex;
  justify-content: center;
  margin: 20px 0 40px;
}
</style>
